import axios from 'axios'
import checkResponse from '../utils/check_response'

const publicApi = axios.create({
    baseURL: "https://api.sms4gold.io"
})

const publicUrlEndpoint = '/api'

export const loginReq = async (body) => {
    const response = await publicApi.post(`${publicUrlEndpoint}/auth/admin/admin_login`, body)
    let data = checkResponse(response.data)
    return data
}

export const refreshTokenReq = async (body) => {
    const response = await publicApi.post(`${publicUrlEndpoint}/auth/admin/refresh_token`, body)
    let data = checkResponse(response.data)
    return data
}